import React from 'react';
import InStockIcon from './inStockIcon.svg';
import LowInventoryIcon from './lowInventoryIcon.svg';
import UnavailableIcon from './unavailableIcon.svg';

export const STATUS_CONFIG = {
  'in-stock': {
    icon: <InStockIcon />,
    text: 'In Stock',
    getClassName: (styles) => `${styles.stock} ${styles['in-stock']}`,
  },
  'low-inventory': {
    icon: <LowInventoryIcon />,
    text: 'Low Inventory',
    getClassName: (styles) => `${styles.stock} ${styles['low-inventory']}`,
  },
  unavailable: {
    icon: <UnavailableIcon />,
    text: 'Unavailable',
    getClassName: (styles) => `${styles.stock} ${styles.unavailable}`,
  },
};

export function getStatusConfig(status, styles) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.unavailable;
  return {
    icon: config.icon,
    text: config.text,
    className: config.getClassName(styles),
  };
}

export function getStatus(availability, { findInStoreInstockQuantity } = {}) {
  if (!availability || !availability?.available) {
    return 'unavailable';
  }
  if (availability?.available >= (findInStoreInstockQuantity || 3)) {
    return 'in-stock';
  }
  if (availability?.available > 0) {
    return 'low-inventory';
  }
  return 'unavailable';
}
